import styled from "styled-components";

export const Container = styled.footer`
  height: 10rem;
  width: 100%;
  background-color: var(--darkBlue);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const PmmcLogo = styled.img`
  width: 13rem;
  max-width: 80%;
`;
